'use client';

import { useState } from 'react';

import { PricingCardsRow } from 'components/website/components/molecules/PricingCardsRow/PricingCardsRow';
import { useTranslations } from 'next-intl';

import { PricingSectionLayout } from './PricingSection/PricingSectionLayout';

export const PricingSection = ({
  data,
  currency,
  coupon = undefined,
  affiliate = undefined,
  noHeader = false,
}: {
  data: {
    [key: string]: {
      price: number;
      basePrice: number;
      recurring: boolean;
      currency: string;
    };
  };
  currency: 'usd' | 'eur';
  coupon?: string;
  affiliate?: string;
  noHeader?: boolean;
}) => {
  const t = useTranslations('section.pricing');

  const [formula, setFormula] = useState('year');

  return (
    <PricingSectionLayout
      id="pricing"
      title={t('title')}
      subtitle={t('subtitle')}
      category={t('category')}
      cardCategories={[
        ...(process.env.NEXT_PUBLIC_PRICING_YEAR === 'true'
          ? [{ value: 'year', label: t('segmentedControl.year') }]
          : []),
        ...(process.env.NEXT_PUBLIC_PRICING_MONTH === 'true'
          ? [{ value: 'month', label: t('segmentedControl.monthly') }]
          : []),
        ...(process.env.NEXT_PUBLIC_PRICING_LIFE === 'true'
          ? [{ value: 'life', label: t('segmentedControl.life') }]
          : []),
      ]}
      onChange={setFormula}
      segmentControlDecorationText={
        process.env.NEXT_PUBLIC_PRICING_LIFE === 'true'
          ? t('segmentedControl.decoration')
          : undefined
      }
      className="section"
      noHeader={noHeader}
    >
      <PricingCardsRow
        key={formula}
        formula={formula}
        coupon={coupon}
        affiliate={affiliate}
        currency={currency}
        data={data}
      />
    </PricingSectionLayout>
  );
};
